import React, { useEffect, useState } from "react";

import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box } from "@mui/material";

import { BaseBadge, BaseLabel, CircularButton, colors } from "components";

import { IMenuList } from "./interface";
import { Container, Header, Body, Right, Left, EmptyMessage } from "./styles";

export const MenuListGeneral: React.FC<IMenuList> = ({
  id,
  title,
  list,
  emptyMessage,
  open,
  showButton = true,
  showListLenght = true,
  titlePaddingLeft,
  titlePaddingRight,
  listPaddingBottom,
  listPaddingLeft,
  listPaddingRight,
  listPaddingTop,
  backgroudColorBody,
  backgroudColorHeader,
  handleButtonClick,
  handleOpen,
  disabled = false,
}) => {
  const [show, setShow] = useState(title.toLowerCase() === open || false);

  useEffect(() => {
    if (!show && open === title.toLowerCase()) {
      setShow(true);
    }

    if (show && !(open === title.toLowerCase())) {
      setShow(false);
    }
  }, []);

  const handleShow = () => {
    if (!disabled) {
      setShow(!show);
      handleOpen(title.toLocaleLowerCase());
    }
  };

  const handleButtonClickAdd = () => {
    if (!disabled) {
      handleButtonClick();
    }
  };

  return (
    <Container id={id} data-testid={"id"}>
      <Header onClick={handleShow} backgroudColor={backgroudColorHeader}>
        <Left>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              left: "0",
            }}
          >
            <BaseLabel
              fontWeight="600"
              fontSize="16px"
              marginRight={titlePaddingRight ?? "20px"}
              marginLeft={titlePaddingLeft ?? "0px"}
            >
              {title}
            </BaseLabel>
            {showListLenght && list.length > 0 ? (
              <BaseBadge content={list.length} />
            ) : (
              <></>
            )}
          </Box>
        </Left>
        <Right>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              right: "0",
            }}
          >
            {showButton ? (
              <Box sx={{ paddingRight: "8px" }}>
                <CircularButton
                  disabled={disabled}
                  icon="add"
                  onClick={handleButtonClickAdd}
                />
              </Box>
            ) : (
              <></>
            )}
            {show ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Box>
        </Right>
      </Header>
      {show && (
        <Body
          paddingleft={listPaddingLeft}
          paddingtop={listPaddingTop}
          paddingright={listPaddingRight}
          paddingbottom={listPaddingBottom}
          backgroudColor={backgroudColorBody}
        >
          {list && list.length > 0 ? (
            list.map((item, index) => <div key={index}>{item}</div>)
          ) : (
            <EmptyMessage>
              <BaseLabel
                fontSize="14px"
                fontStyle="italic"
                color={colors.neutral_gray_40}
                marginLeft="0px"
              >
                {emptyMessage}
              </BaseLabel>
            </EmptyMessage>
          )}
        </Body>
      )}
    </Container>
  );
};
